import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Printer, Flag } from 'lucide-react';
interface Tomo {
  num: number;
  dot: string;
  cat: string;
  range: string;
  desc: string;
}
export function Producto() {
  const tomos: Tomo[] = [{
    num: 1,
    dot: 'bg-green-500',
    cat: '🟢 Minis',
    range: 'Período 1 (4 a 8 años)',
    desc: 'Exploración motriz y vínculo con la pelota. Las primeras 17 semanas del año listas.'
  }, {
    num: 2,
    dot: 'bg-green-500',
    cat: '🟢 Minis',
    range: 'Período 2 (4 a 8 años)',
    desc: 'Iniciación al juego colectivo. Pase, movimiento y primeras nociones de equipo.'
  }, {
    num: 3,
    dot: 'bg-green-500',
    cat: '🟢 Minis',
    range: 'Período 3 (4 a 8 años)',
    desc: 'Situaciones reales de juego, sistemas simples y cierre anual con evaluación.'
  }, {
    num: 4,
    dot: 'bg-blue-500',
    cat: '🔵 Infantiles',
    range: 'Período 1 (9 a 12 años)',
    desc: 'Fundamentos técnico-tácticos. Conducción, pase filtrado, regate y tiro formal.'
  }, {
    num: 5,
    dot: 'bg-blue-500',
    cat: '🔵 Infantiles',
    range: 'Período 2 (9 a 12 años)',
    desc: 'Táctica colectiva. Sistemas ofensivos y defensivos en partidos reales.'
  }, {
    num: 6,
    dot: 'bg-blue-500',
    cat: '🔵 Infantiles',
    range: 'Período 3 (9 a 12 años)',
    desc: 'Competencia real, análisis de partido y evaluación individual de cierre.'
  }, {
    num: 7,
    dot: 'bg-yellow-500',
    cat: '🟡 Menores',
    range: 'Período 1 (13 a 15 años)',
    desc: 'Físico-técnico por posición. Alta intensidad y fundamentos avanzados.'
  }, {
    num: 8,
    dot: 'bg-yellow-500',
    cat: '🟡 Menores',
    range: 'Período 2 (13 a 15 años)',
    desc: 'Sistemas tácticos 11v11. Presión, salida y transiciones en competencia.'
  }, {
    num: 9,
    dot: 'bg-yellow-500',
    cat: '🟡 Menores',
    range: 'Período 3 (13 a 15 años)',
    desc: 'Competencia élite y análisis avanzado de rendimiento individual y grupal.'
  }, {
    num: 10,
    dot: 'bg-orange-500',
    cat: '🟠 Juveniles',
    range: 'Período 1 (16 a 18 años)',
    desc: 'Alto rendimiento físico y táctico. Preparación para el fútbol adulto.'
  }, {
    num: 11,
    dot: 'bg-orange-500',
    cat: '🟠 Juveniles',
    range: 'Período 2 (16 a 18 años)',
    desc: 'Táctica avanzada. Sistemas complejos y gestión de la competencia élite.'
  }, {
    num: 12,
    dot: 'bg-orange-500',
    cat: '🟠 Juveniles',
    range: 'Período 3 (16 a 18 años)',
    desc: 'Portafolio del jugador y proyección al fútbol de primera categoría.'
  }, {
    num: 13,
    dot: 'bg-red-500',
    cat: '🔴 Mayores',
    range: 'Período 1 (19+ años)',
    desc: 'Diagnóstico de plantel y construcción de la base táctica y física anual.'
  }, {
    num: 14,
    dot: 'bg-red-500',
    cat: '🔴 Mayores',
    range: 'Período 2 (19+ años)',
    desc: 'Temporada completa planificada. Semana a semana sin improvisar nada.'
  }, {
    num: 15,
    dot: 'bg-red-500',
    cat: '🔴 Mayores',
    range: 'Período 3 (19+ años)',
    desc: 'Definición de temporada, gestión de la final y cierre total del sistema.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-content mx-auto" data-id="element-248">
      <div className="text-center mb-16" data-id="element-249">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-block py-1 px-3 rounded-full bg-f360-green text-white text-sm font-bold tracking-wide uppercase mb-6" data-id="element-250">
          🏆 El Sistema N°1 para Entrenadores de Fútbol Argentinos
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-12" data-id="element-251">
          FÚTBOL 360 — Colección Completa
          <br data-id="element-252" />
          <span className="text-f360-green" data-id="element-253">
            15 Tomos + 6 Bonus + 2 Élite —
          </span>
          <br data-id="element-254" />
          Todo resuelto, todas las edades.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-255">
          <div className="text-center p-4" data-id="element-256">
            <p className="text-2xl font-black text-gray-900" data-id="element-257">+285</p>
            <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-258">
              páginas de contenido
            </p>
          </div>
          <div className="text-center p-4 md:border-l border-gray-100" data-id="element-259">
            <p className="text-2xl font-black text-gray-900" data-id="element-260">+260</p>
            <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-261">
              sesiones planificadas
            </p>
          </div>
          <div className="text-center p-4 md:border-l border-gray-100" data-id="element-262">
            <p className="text-2xl font-black text-gray-900" data-id="element-263">
              Todas las edades
            </p>
            <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-264">
              4 a 19+ años
            </p>
          </div>
          <div className="text-center p-4 md:border-l border-gray-100" data-id="element-265">
            <p className="text-2xl font-black text-gray-900" data-id="element-266">5 categorías</p>
            <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-267">completas</p>
          </div>
        </motion.div>
      </div>

      <div className="mb-12 text-center" data-id="element-268">
        <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2" data-id="element-269">
          Los 15 Tomos Completos
        </h3>
        <p className="text-lg text-gray-600" data-id="element-270">
          Sesiones listas · Por edad y objetivo · Usalo mañana mismo
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-271">
        {tomos.map((tomo, index) => <motion.div key={tomo.num} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index % 3 * 0.1
      }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-272">
            <div className={`absolute top-0 left-0 w-1.5 h-full ${tomo.dot}`} data-id="element-273" />
            <div className="flex items-center justify-between mb-3 pl-2" data-id="element-274">
              <span className="text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-275">
                TOMO {tomo.num}
              </span>
              <span className="text-sm font-bold" data-id="element-276">{tomo.cat}</span>
            </div>
            <h4 className="text-base font-bold text-gray-900 mb-2 leading-tight pl-2" data-id="element-277">
              {tomo.cat.split(' ')[1]} — {tomo.range}
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed pl-2" data-id="element-278">
              {tomo.desc}
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-f360-green text-white rounded-2xl p-6 sm:p-8 flex flex-wrap justify-center gap-6 sm:gap-10" data-id="element-279">
        <div className="flex items-center gap-3" data-id="element-280">
          <FileText className="w-6 h-6 text-f360-gold" data-id="element-281" />
          <span className="font-medium" data-id="element-282">Sesiones detalladas en cada tomo</span>
        </div>
        <div className="flex items-center gap-3" data-id="element-283">
          <Zap className="w-6 h-6 text-f360-gold" data-id="element-284" />
          <span className="font-medium" data-id="element-285">Sistema "Abrí y Entrenás"</span>
        </div>
        <div className="flex items-center gap-3" data-id="element-286">
          <Printer className="w-6 h-6 text-f360-gold" data-id="element-287" />
          <span className="font-medium" data-id="element-288">Fichas listas para imprimir</span>
        </div>
        <div className="flex items-center gap-3" data-id="element-289">
          <Flag className="w-6 h-6 text-f360-gold" data-id="element-290" />
          <span className="font-medium" data-id="element-291">100% adaptado al fútbol argentino</span>
        </div>
      </motion.div>
    </section>;
}